import Vue from 'vue';
import Vuex from 'vuex';

import Message from '@/models/MessageModel';
import router from '@/router';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fetch: false,
    messages: [],
    header: true,
    headerTitle: null,
    headerBack: false,
    headerSearch: false,
    headerUpdate: false,
    headerNext: false,
    menu: false,
    authorized: false,
    user: {},
    properties: {},
    cities: [],
    city: null,
    states: [],
    state: null,
    neighborhoods: [],
    neighborhood: null,
    priceStart: null,
    priceStop: null,
    propertySelected: null,
    terms: '',
    rent: false,
    sale: false,
  },
  mutations: {
    menuShow(state) {
      state.menu = true;
    },
    menuHide(state) {
      state.menu = false;
    },
    authorized(state, user) {
      state.authorized = true;
      state.user = user;
    },
    unauthorized(state) {
      state.authorized = false;
      state.user = {};
    },
    updateTerms(state, term) {
      state.terms = term;
    },
    updateRent(state, mode = null) {
      if (mode !== null) {
        state.rent = mode;
        return;
      }
      state.rent = !state.rent;
    },
    updateSale(state, mode = null) {
      if (mode !== null) {
        state.sale = mode;
        return;
      }
      state.sale = !state.sale;
    },
    fetchActive(state) {
      state.fetch = true;
    },
    fetchInactive(state) {
      state.fetch = false;
    },
    properties(state, properties) {
      state.properties = properties;
    },
    propertySelected(state, property) {
      state.propertySelected = property;
    },
    removeMessage(state, uid) {
      const { messages } = state;
      state.messages = messages.filter((message) => message.uid !== uid);
    },
    addMessage(state, message) {
      const { messages } = state;
      messages.push(message);
      state.messages = messages;
    },
    header(state, header) {
      state.header = header;
    },
    headerModeLogin(state) {
      state.header = false;
      state.headerTitle = null;
      state.headerBack = false;
      state.headerSearch = false;
      state.headerNext = false;
      state.headerUpdate = false;
      state.menu = false;
    },
    headerModeAuth(state) {
      state.header = true;
      state.headerTitle = null;
      state.headerBack = false;
      state.headerSearch = true;
      state.headerNext = false;
      state.headerUpdate = false;
      state.menu = false;
    },
    headerModeApp(state, title) {
      state.header = true;
      state.headerTitle = title || ' ';
      state.headerBack = true;
      state.headerSearch = false;
      state.headerNext = false;
      state.headerUpdate = false;
      state.menu = false;
    },
    headerTitle(state, value) {
      state.headerTitle = value;
    },
    headerBack(state, value) {
      state.headerBack = value;
    },
    headerSearch(state, value) {
      state.headerSearch = value;
    },
    headerNext(state, route) {
      state.headerNext = route;
    },
    headerUpdate(state, route) {
      state.headerUpdate = route;
    },
    updateCity(state, city) {
      state.city = city;
    },
    updateCities(state, cities) {
      const clearCities = [...new Set(cities)];
      localStorage.setItem('cities', JSON.stringify(clearCities));
      state.cities = clearCities;
    },
    updateState(state, selState) {
      state.state = selState;
    },
    updateStates(state, states) {
      const clearStates = [...new Set(states)];
      localStorage.setItem('states', JSON.stringify(clearStates));
      state.states = clearStates;
    },
    updateNeighborhood(state, neighborhood) {
      state.neighborhood = neighborhood;
    },
    updateNeighborhoods(state, neighborhoods) {
      const clearNeighborhoods = [...new Set(neighborhoods)];
      localStorage.setItem('neighborhoods', JSON.stringify(clearNeighborhoods));
      state.neighborhoods = clearNeighborhoods;
    },
    updatePriceStart(state, value) {
      state.priceStart = value;
    },
    updatePriceStop(state, value) {
      state.priceStop = value;
    },
  },
  actions: {
    addMessageDefault(context, title) {
      const message = new Message(title);
      context.commit('addMessage', message);
      setTimeout(() => {
        context.commit('removeMessage', message.uid);
      }, 12000);
    },
    addMessageSuccess(context, title) {
      const message = new Message(title).success();
      context.commit('addMessage', message);
      setTimeout(() => {
        context.commit('removeMessage', message.uid);
      }, 12000);
    },
    addMessageError(context, title) {
      const message = new Message(title).error();
      context.commit('addMessage', message);
      setTimeout(() => {
        context.commit('removeMessage', message.uid);
      }, 12000);
    },
    addMessageErrorDontClose(context, title) {
      const message = new Message(title).error().dontClose();
      context.commit('addMessage', message);
      setTimeout(() => {
        context.commit('removeMessage', message.uid);
      }, 120000);
    },

    async login(context, payload) {
      const { email, password } = payload;
      const user = new FormData();
      user.append('email', email);
      user.append('password', password);

      let result = null;
      try {
        result = await Vue.axios.post(
          '/auth/login',
          user,
        );
      } catch (e) {
        context.dispatch('addMessageError', 'Desculpe não foi possivel autenticar.');
        return;
      }


      localStorage.setItem('jwtToken', result.data.access_token);
      context.dispatch('getDataUser');
      context.dispatch('getDataProperties');
    },
    async getDataUser(context) {
      const jwtoken = localStorage.getItem('jwtToken');
      if (!jwtoken) {
        context.dispatch('addMessageError', 'Ops, algo deu errado.');
        context.commit('unauthorized');
        return;
      }

      const auth = new FormData();
      auth.append('token', jwtoken);

      let result = null;
      try {
        result = await Vue.axios.post(
          '/me',
          auth,
        );
      } catch (e) {
        context.dispatch('addMessageError', 'Desculpe não foi possível obter as informações.');
        return;
      }


      context.commit('authorized', result.data.data);
      localStorage.setItem('user', JSON.stringify(result.data.data));
      context.dispatch('addMessageSuccess', `Bem vindo ${result.data.data.name}`);
      router.push({ name: 'auth.dashboard' });
    },
    async getDataProperties(context) {
      const jwtoken = localStorage.getItem('jwtToken');
      if (!jwtoken) {
        context.dispatch('addMessageError', 'Ops, algo deu errado.');
        context.commit('unauthorized');
        return;
      }

      const auth = new FormData();
      auth.append('token', jwtoken);

      let result = null;
      try {
        result = await Vue.axios.post(
          '/properties',
          auth,
        );
      } catch (e) {
        context.dispatch('addMessageError', 'Desculpe não foi possível obter as informações.');
        return;
      }

      const searchableData = await context.dispatch('prepareToSearch', { properties: result.data.data });

      context.commit('properties', searchableData);
      localStorage.setItem('properties', JSON.stringify(searchableData));
      context.dispatch('addMessageSuccess', 'Atualizado');
    },
    async prepareToSearch(context, payload) {
      const { properties } = payload;
      if (!properties || !properties.length) return [];
      const cities = [];
      const neighborhoods = [];
      const states = [];

      const finallyProperties = properties.map((property) => {
        let searchText = `${property.title} `;
        searchText += `${property.description} `;
        searchText += `${property.address.street} `;
        searchText += `${property.address.number} `;
        searchText += `${property.address.complement} `;
        searchText += `${property.address.city} `;
        searchText += `${property.address.state} `;
        searchText += `${property.address.zipcode} `;
        searchText += `${property.address.neighborhood} `;
        searchText += `${property.price.rent} `;
        searchText += `${property.price.sale} `;

        cities.push(property.address.city);
        states.push(property.address.state);
        neighborhoods.push(property.address.neighborhood);

        const newProperty = property;
        newProperty.searchText = searchText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        return newProperty;
      });

      context.commit('updateCities', cities);
      context.commit('updateNeighborhoods', neighborhoods);
      context.commit('updateStates', states);

      return finallyProperties;
    },
    logout(context) {
      localStorage.removeItem('user');
      localStorage.removeItem('properties');
      localStorage.removeItem('jwtToken');
      context.commit('unauthorized');
      router.push({ name: 'login' });
    },
  },
  modules: {
  },
});
